import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { Card } from "@/components/ui/card";
import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Mail, MessageCircle, Inbox } from "lucide-react";
import { api } from "@/lib/api";
import { formatDateTime } from "@/lib/format";

const STATUS_TONE = {
  sent: "bg-emerald-100 text-emerald-800 border-emerald-200",
  sent_mock: "bg-blue-100 text-blue-800 border-blue-200",
  failed: "bg-rose-100 text-rose-800 border-rose-200",
  pending: "bg-amber-100 text-amber-800 border-amber-200",
};

const STATUS_LABEL = {
  sent: "Enviado",
  sent_mock: "MOCK enviado",
  failed: "Falhou",
  pending: "Pendente",
};

const EVENT_LABEL = {
  lead_nurture: "Lead capture",
  occurrence_assigned: "Ocorrência atribuída",
  checklist_overdue: "Checklist atrasado",
  rule_action: "Regra acionada",
  info: "Informação",
};

export default function Notifications() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/notifications?limit=300").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  return (
    <Layout title="Notificações" subtitle="Email e WhatsApp enviados pela plataforma">
      <Card data-testid="notifications-page" className="rounded-xl border-stone-200 bg-white overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-stone-50">
              <TableHead className="font-body">Quando</TableHead>
              <TableHead className="font-body">Canal</TableHead>
              <TableHead className="font-body">Destinatário</TableHead>
              <TableHead className="font-body">Evento</TableHead>
              <TableHead className="font-body">Assunto / Mensagem</TableHead>
              <TableHead className="font-body">Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className="text-center text-stone-500 py-10">
                  <Inbox className="h-6 w-6 mx-auto mb-2 text-stone-400" />
                  Nenhuma notificação registrada
                </TableCell>
              </TableRow>
            )}
            {items.map((n) => (
              <TableRow key={n.id} data-testid={`notification-row-${n.id}`}>
                <TableCell className="font-body text-sm">{formatDateTime(n.created_at)}</TableCell>
                <TableCell>
                  <Badge variant="outline" className="border-stone-300 inline-flex items-center gap-1">
                    {n.channel === "email" ? <Mail className="h-3 w-3" /> : <MessageCircle className="h-3 w-3" />}
                    {n.channel}
                  </Badge>
                </TableCell>
                <TableCell className="font-body text-sm">{n.to}</TableCell>
                <TableCell className="font-body text-xs">{EVENT_LABEL[n.event_type] || n.event_type}</TableCell>
                <TableCell className="font-body text-sm max-w-md truncate">
                  <div className="font-semibold truncate">{n.subject || "—"}</div>
                  {n.error && <div className="text-xs text-rose-600 truncate">{n.error}</div>}
                </TableCell>
                <TableCell>
                  <Badge variant="outline" className={STATUS_TONE[n.status] || ""}>
                    {STATUS_LABEL[n.status] || n.status}
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </Layout>
  );
}
